import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
export function ModuleBreakdown() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const modules = [{
    number: '1',
    title: 'El Mercado de Oro',
    duration: '15 min',
    description: 'Cómo identificar los negocios locales con mayor urgencia de tener un sitio web y mayor disposición a pagar.',
    image: 'https://cdn.magicpatterns.com/uploads/tkXRVtrgauyVWdxQvGFHru/module_cover_1.png'
  }, {
    number: '2',
    title: 'El Cerebro Cazador',
    duration: '20 min',
    description: 'Cómo usar el cerebro de IA "Local Scout" para encontrar 10 prospectos en menos de 15 minutos.',
    image: 'https://cdn.magicpatterns.com/uploads/eJfxBN6QkBSWZB5XAeNF1F/module_cover_2.png'
  }, {
    number: '3',
    title: 'La Demo que Cierra Sola',
    duration: '20 min',
    description: 'Cómo usar el cerebro de IA "Web Builder" para construir una demo del sitio del cliente antes de hablar con él.',
    image: 'https://cdn.magicpatterns.com/uploads/trhhSx8quD9byWXrxE5H5y/module_cover_3.png'
  }, {
    number: '4',
    title: 'El Cierre Sin Presión',
    duration: '15 min',
    description: 'Cómo usar el guion de cierre para convertir una conversación casual en una venta de $350.',
    image: 'https://cdn.magicpatterns.com/uploads/65RLizDBHeQBTBuZW3c9Hu/module_cover_4.png'
  }];
  return <section ref={ref} className="w-full py-20 px-4" data-id="element-421">
      <div className="max-w-6xl mx-auto" data-id="element-422">
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 50
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-423">
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl mb-4" data-id="element-424">
            Lo que Aprenderás en Cada Módulo
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-425">
          {modules.map((module, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 50
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 50
        }} transition={{
          duration: 0.6,
          delay: 0.2 + index * 0.1
        }} className="bg-gradient-to-br from-navy-dark to-navy border border-gold/20 rounded-xl overflow-hidden hover:border-gold/40 transition-all hover:shadow-xl hover:shadow-gold/10" data-id="element-426">
              <div className="relative w-full aspect-video overflow-hidden" data-id="element-427">
                <img src={module.image} alt={`Módulo ${module.number} - ${module.title}`} className="w-full h-full object-cover" data-id="element-428" />
              </div>

              <div className="p-8" data-id="element-429">
                <div className="flex items-start gap-4 mb-4" data-id="element-430">
                  <div className="flex-shrink-0 w-12 h-12 bg-gold rounded-lg flex items-center justify-center" data-id="element-431">
                    <span className="font-heading font-black text-2xl text-navy" data-id="element-432">
                      {module.number}
                    </span>
                  </div>
                  <div className="flex-1" data-id="element-433">
                    <h3 className="font-heading font-bold text-xl md:text-2xl mb-2" data-id="element-434">
                      MÓDULO {module.number} — {module.title}
                    </h3>
                    <div className="flex items-center gap-2 text-gold" data-id="element-435">
                      <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-436" />
                      <span className="font-body text-sm font-semibold" data-id="element-437">
                        {module.duration}
                      </span>
                    </div>
                  </div>
                </div>
                <p className="font-body text-base text-gray-300 leading-relaxed" data-id="element-438">
                  {module.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}